import { render, staticRenderFns } from "./AlertMessage.vue?vue&type=template&id=1dc41583&scoped=true&"
import script from "./AlertMessage.vue?vue&type=script&lang=ts&"
export * from "./AlertMessage.vue?vue&type=script&lang=ts&"
import style0 from "./AlertMessage.vue?vue&type=style&index=0&id=1dc41583&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc41583",
  null
  
)

export default component.exports